import { render } from "./AdminGroups.vue?vue&type=template&id=f3c5f890&scoped=true"
import script from "./AdminGroups.vue?vue&type=script&lang=js"
export * from "./AdminGroups.vue?vue&type=script&lang=js"

import "./AdminGroups.vue?vue&type=style&index=0&id=f3c5f890&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c5f890"]])

export default __exports__